import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FilledXCircleIconIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "FilledXCircleIcon",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M16 1.14C7.79 1.14 1.14 7.79 1.14 16S7.79 30.86 16 30.86 30.86 24.2 30.86 16 24.2 1.14 16 1.14m5.38 18.62a1.14 1.14 0 0 1-.81 1.95c-.29 0-.58-.11-.81-.33L16 17.62l-3.76 3.76c-.23.22-.52.33-.81.33s-.59-.11-.81-.33a1.14 1.14 0 0 1 0-1.62L14.38 16l-3.76-3.76a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0L16 14.38l3.76-3.76a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62L17.62 16z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M16 0C7.18 0 0 7.18 0 16s7.18 16 16 16 16-7.18 16-16S24.82 0 16 0m0 29.71C8.44 29.71 2.29 23.56 2.29 16S8.44 2.28 16 2.28 29.71 8.44 29.71 16 23.56 29.71 16 29.71"
    })]
  }));
};
FilledXCircleIconIcon.displayName = 'FilledXCircleIconIcon';